import { OptionProps } from 'components/Common/Form/Select';

export enum Types {
	CONSULTAR_PARAMETROS_LOCALIDADE_V2 = '@SGU/CONSULTAR_PARAMETROS_LOCALIDADE_V2',
	CONSULTAR_PARAMETROS_LOCALIDADE_V2_SUCCESS = '@SGU/CONSULTAR_PARAMETROS_LOCALIDADE_V2_SUCCESS',
	CONSULTAR_PARAMETROS_LOCALIDADE_V2_FAILURE = '@SGU/CONSULTAR_PARAMETROS_LOCALIDADE_V2_FAILURE',
	CONSULTAR_PARAMETROS_LOCALIDADE_V2_CLEAR = '@SGU/CONSULTAR_PARAMETROS_LOCALIDADE_V2_CLEAR',
}

export interface ConsultarParametrosLocalidadeV2 {
	status: number;
	data: string[] | null;
	enum: OptionProps[];
	// totalRegistrosConsulta: number;
}

export interface ConsultarParametrosLocalidadeV2Request {
	sigla?: string;
	idOrgao: number | string;
}
